import FormPage from './formPage';
import FieldSelect from './fields/fieldSelect';
import FieldText from './fields/fieldText';
import FieldDate from './fields/fieldDate';
import FieldYesNo from './fields/fieldYesNo';
import FieldNumeric from './fields/fieldNumeric';
import LegalDetails from './legalDetails';

export default class FrontVous extends FormPage {
    constructor(props) {
        super(props);
        this.title = 'Vous'
        this.state = {
            showValidate:false,
            cities:[],
            cp:''
        }
        this.fields = {
            'date_naissance':true,
            'situation_famille':true,
            'nombre_enfants':true,
            'civilite':true,
            'nom':true,
            'prenom':true,
            'adresse':true,
            'code_postal':true,
            'ville':true,
            'telephone':true,
            'email':true,
            'ne_en_france':{
                'commune_naissance':true,
                'pays_naissance':false
            },
            'norme_permis':true,
            'categorie_permis':true,
            'date_obtention_permis':true,
            'aussi_permis_A2':{
                'date_obtention_permis_A2':true
            },
            'assure_actuellement':true,
            'coefficient_auto':true,
            'coefficient_moto':true,
            'bonus_50_plus_3_ans':true,
            'assure_12_sur_36':true
        }
    }


    next() {
        this.props.setPage('antecedents')
    }

    back() {
        this.props.setPage('vehicule')
    }

    componentDidMount() {
        this.updateCities()
    }

    componentDidUpdate( prevProps, prevState ) {
        if ( this.props.devis.params.code_postal != prevProps.devis.params.code_postal ) {
            this.updateCities()
        }
    }

    updateCities() {
        const code_postal = this.props.devis.params.code_postal
        const me = this
        if ( code_postal ) {
            this.props.api.post(
                {
                    action:'resolve_cp',
                    cp:code_postal
                },
                (res)=>{
                    if ( me.props.devis.params.code_postal == res.cp ) {
                        this.setState({
                            cities:res.cities.map( city => ({ value:city, label:city }) ),
                            cp: res.cp
                        })
                    }
                }
            )
        } else {
            this.setState({cities:[],cp:code_postal})
        }
    }

    doRender(container) {
        const me = this
        const params = this.props.devis.params
        return <>
            <div className="contentvbox">
            <h1 className="top_title">Vous</h1>
            <FieldDate field="date_naissance" container={container}/>
            <FieldSelect field="situation_famille" container={container} />
            <FieldNumeric field="nombre_enfants" container={container}  min="0" max="16" />
            <FieldSelect field="civilite" container={container} />
            <FieldText field="nom" container={container}/>
            <FieldText field="prenom" container={container}/>
            <FieldText field="chez" container={container}/>
            <FieldText field="adresse2" container={container}/>
            <FieldText field="adresse" container={container}/>
            <FieldText 
                field="code_postal" 
                container={container}
                onValidate={ value => ( this.state.cp == value ) ? false : 'Le code postal et la ville sont en cours de vérification. Merci de patienter quelques secondes , ou rechargez la page.' }
                />
            <FieldSelect 
                field="ville" 
                container={container} 
                options={this.state.cities}
                onValidate={ 
                    value => {
                        console.log(this.state.cities, value)
                        return this.state.cities.some( entry => entry.value == value ) ? false : 'La ville ne correspond pas au code postal' 
                    }
                }
            />
            <FieldText field="telephone" container={container}/>
            <FieldText field="email" container={container}/>

            <FieldText field="commune_naissance" label="Commune de naissance (France uniquement)" container={container} />
            <i>Sans code postal. Exemple: Paris</i>
            <FieldSelect field="pays_naissance" label="ou pays de naissance" container={container}/>


            <FieldSelect field="norme_permis" container={container}  />
            <FieldSelect field="categorie_permis" container={container}  />
            <FieldDate field="date_obtention_permis" container={container}  />

            <LegalDetails container={container} />

            <FieldYesNo field="assure_actuellement" container={container} />
            <FieldText field="coefficient_auto" container={container}/>
            <i>Entre 50 (bonus maximal) et 350 (malus maximal)</i>
            <FieldText field="coefficient_moto" container={container}/>
            <i>Entre 50 (bonus maximal) et 350 (malus maximal)</i>
            { (( parseInt(params.coefficient_moto) <= 50 )||( parseInt(params.coefficient_auto) <= 50 ))
            ? <FieldYesNo field="bonus_50_plus_3_ans" container={container} />
            : '' }
            <FieldYesNo field="assure_12_sur_36" container={container} />
            </div>

            
        </>
    }
}
